module.exports = __webpack_public_path__ + "static/media/5@960w.55f22b38.jpg";